/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Unranked_Reason_Few_PlayersInputs */



/**
* | output |
* | --- |
* | "fewer than 8 players" |
*
* @param {Tournament_Unranked_Reason_Few_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_unranked_reason_few_players = /** @type {((inputs?: Tournament_Unranked_Reason_Few_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Unranked_Reason_Few_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("moins de 8 joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("menos de 8 jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("menos de 8 jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("meno di 8 giocatori")
	return /** @type {LocalizedString} */ ("fewer than 8 players")
});